import { singleton, inject } from "tsyringe";
import FractionalIndexing from "@/shared/libs/create-order-key/frational-indexing/FractionalIndexing";

import type { CreateOrderKeyImpl } from "@/shared/libs/create-order-key/interface";

@singleton()
export default class CreateOrderKeyAdapter implements CreateOrderKeyImpl {
    constructor(
        @inject(FractionalIndexing) private readonly fractionalIndexing: FractionalIndexing,
    ) {}

    public generateKeyBetween = (start: string | null, end: string | null) => {
        return this.fractionalIndexing.generateKeyBetween(start, end);
    };

    public generateNKeysBetween = (start: string | null, end: string | null, n: number) => {
        return this.fractionalIndexing.generateNKeysBetween(start, end, n);
    };
}
